import React from 'react';
import { motion } from 'framer-motion';
import { accountsData } from '../data/mockData';
import StatusBadge from '../components/ui/StatusBadge';
import RiskPulse from '../components/ui/RiskPulse';
import SafeIcon from '../common/SafeIcon';
import { FiFilter, FiDownload, FiMoreVertical } from 'react-icons/fi';

const Accounts = () => {
  return (
    <div className="max-w-7xl mx-auto space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-white tracking-tight">Account Portfolio</h1>
          <p className="text-slate-400 mt-2">Manage and monitor all customer health metrics.</p>
        </div>
        <div className="flex gap-3">
          <button className="px-4 py-2 bg-[#13131a] border border-white/10 hover:bg-white/5 text-slate-300 rounded-lg text-sm font-medium transition-colors flex items-center gap-2">
            <SafeIcon icon={FiFilter} /> Filter
          </button>
          <button className="px-4 py-2 bg-[#13131a] border border-white/10 hover:bg-white/5 text-slate-300 rounded-lg text-sm font-medium transition-colors flex items-center gap-2">
            <SafeIcon icon={FiDownload} /> Export
          </button>
        </div>
      </div>

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-[#13131a] border border-white/5 rounded-2xl overflow-hidden"
      >
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-white/[0.02] border-b border-white/5 text-xs uppercase tracking-wider text-slate-500">
                <th className="p-5 font-medium">Account Name</th>
                <th className="p-5 font-medium">Status</th>
                <th className="p-5 font-medium">Health Score</th>
                <th className="p-5 font-medium">ARR</th>
                <th className="p-5 font-medium">Renewal Date</th>
                <th className="p-5 font-medium text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5 text-sm">
              {accountsData.map((account, idx) => (
                <motion.tr 
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.05 }}
                  key={account.id} 
                  className="hover:bg-white/[0.02] transition-colors group cursor-pointer"
                >
                  <td className="p-5">
                    <div className="flex items-center gap-3">
                      <RiskPulse level={account.pulse} />
                      <span className="font-medium text-slate-200 group-hover:text-violet-400 transition-colors">{account.name}</span>
                    </div>
                    {account.riskReason && (
                      <p className="text-xs text-rose-400/70 mt-1 ml-7">{account.riskReason}</p>
                    )}
                  </td>
                  <td className="p-5">
                    <StatusBadge health={account.health} />
                  </td>
                  <td className="p-5">
                    <div className="flex items-center gap-3">
                      <span className={`font-mono font-medium ${account.health < 50 ? 'text-rose-400' : account.health < 80 ? 'text-amber-400' : 'text-emerald-400'}`}>
                        {account.health}
                      </span>
                      <div className="w-24 h-1.5 bg-white/10 rounded-full overflow-hidden">
                        <div 
                          className={`h-full rounded-full ${account.health < 50 ? 'bg-rose-500' : account.health < 80 ? 'bg-amber-500' : 'bg-emerald-500'}`}
                          style={{ width: `${account.health}%` }}
                        ></div>
                      </div>
                    </div>
                  </td>
                  <td className="p-5 font-mono text-slate-300">{account.arr}</td>
                  <td className="p-5 text-slate-400">{account.renewal}</td>
                  <td className="p-5 text-right">
                    <button className="p-2 text-slate-500 hover:text-white hover:bg-white/10 rounded-lg transition-colors">
                      <SafeIcon icon={FiMoreVertical} />
                    </button>
                  </td>
                </motion.tr>
              ))}
            </tbody>
          </table>
        </div>
      </motion.div>
    </div>
  );
};

export default Accounts;